<app-pop-up [id]="'authorization-enabled'">
	<div class="popup authorization-enabled-popup">
		<button
			class="button-reset close"
			(click)="close()"
		></button>
		<div class="popup-content">
			<section class="popup-header">
				<h2 class="popup-header__title">
					В браузере заблокированна поддержка сохранения cookies
				</h2>
				<p class="description">
					Для корректной работы в Интернет-банке необходимо разрешить сохранение cookies в
					вашем браузере.
				</p>
			</section>
			<div class="popup-footer">
				<button
					class="button"
					(click)="close()"
				>
					Ok
				</button>
			</div>
		</div>
	</div>
</app-pop-up>
